/**
 * The sign-in page's default copy (the rule is in `shared.ts`): its heading, the email form, and
 * what it says once the link is sent. The consent line under the form is the platform's
 * (`storefrontSignIn.ts`).
 */
import { SIGN_IN_LINK_TTL_MINUTES } from "../storefrontSignIn.js";

/** The sign-in page's words, in the store's name. */
export interface LoginCopy {
  /** The page's h1, naming the store. */
  title: string;
  description: string;
  /** The field's accessible name, and the hint it shows while empty. */
  email: { label: string; placeholder: string };
  /** The form's action, and its words while the request is out. */
  submit: { label: string; busyLabel: string };
  /** Once sent: the words either side of the shopper's email, and the way back to the form. */
  sent: { before: string; after: string; reset: string };
}

export function defaultLoginCopy({
  storeName,
}: {
  /** The store's display name. */
  storeName: string;
}): LoginCopy {
  return {
    title: `Sign in to ${storeName}`,
    description:
      "We'll email you a magic link — no password needed. Your pulls and balance persist to your account.",
    email: { label: "Email", placeholder: "you@example.com" },
    submit: { label: "Email me a sign-in link", busyLabel: "Sending…" },
    sent: {
      before: "Check your email — we sent a sign-in link to ",
      after: `. It's valid for ${SIGN_IN_LINK_TTL_MINUTES} minutes.`,
      reset: "Use a different email",
    },
  };
}
